const commonActionTypes = {
  SET_CONTEXT: 'SET_CONTEXT',

  FETCH_ALL_LABS: 'FETCH_ALL_LABS',
  FETCH_ALL_LABS_SUCCESS: 'FETCH_ALL_LABS_SUCCESS',
  FETCH_ALL_LABS_FAIL: 'FETCH_ALL_LABS_FAIL',

  FETCH_ALL_CHEMISTS: 'FETCH_ALL_CHEMISTS',
  FETCH_ALL_CHEMISTS_SUCCESS: 'FETCH_ALL_CHEMISTS_SUCCESS',
  FETCH_ALL_CHEMISTS_FAIL: 'FETCH_ALL_CHEMISTS_FAIL',

  FETCH_ALL_USERS: 'FETCH_ALL_USERS',
  FETCH_ALL_USERS_SUCCESS: 'FETCH_ALL_USERS_SUCCESS',
  FETCH_ALL_USERS_FAIL: 'FETCH_ALL_USERS_FAIL',

  FETCH_UPLOAD_CONTENT_SUBMISSION: 'FETCH_UPLOAD_CONTENT_SUBMISSION',
  FETCH_UPLOAD_CONTENT_SUBMISSION_SUCCESS: 'FETCH_UPLOAD_CONTENT_SUBMISSION_SUCCESS',
  FETCH_UPLOAD_CONTENT_SUBMISSION_FAIL: 'FETCH_UPLOAD_CONTENT_SUBMISSION_FAIL',
};

export default commonActionTypes;
